"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../Button"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PredefinedButtonHoc = function PredefinedButtonHoc(locale) {
  return function (props) {
    var name = props.name;
    var callbackOrElement = props[name];
    if (!callbackOrElement) return null;
    var buttontypes = {
      onAdd: {
        children: locale.add,
        title: locale.add,
        icon: 'plus'
      },
      onRefresh: {
        children: locale.refresh,
        title: locale.refresh,
        icon: 'refresh'
      },
      onExcelExport: {
        children: locale.excelExport,
        title: locale.excelExport,
        icon: 'excel'
      },
      onCsvExport: {
        children: locale.csvExport,
        title: locale.csvExport,
        icon: 'csv'
      },
      onPdfExport: {
        children: locale.pdfExport,
        title: locale.pdfExport,
        icon: 'pdf'
      },
      onMaximize: {
        icon: props.maximized ? 'compress' : 'expand'
      }
    };

    /**
     * tablo ve header small size ise ön tanımlı buton yeni xsmall size'ı kullanır,
     * değil ise mevcuttaki gibi small size'ı kullanmaya devam eder
     */
    var buttonSize = props.size === 'small' ? 'xsmall' : 'small';
    var buttonProps = _objectSpread({
      type: 'primary',
      size: buttonSize
    }, buttontypes[name]);
    if (/*#__PURE__*/_react.default.isValidElement(callbackOrElement)) {
      return /*#__PURE__*/_react.default.cloneElement(callbackOrElement, buttonProps);
    }
    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
      onClick: function onClick(e) {
        e.preventDefault();
        callbackOrElement(e);
      }
    }, buttonProps));
  };
};
var _default = exports.default = PredefinedButtonHoc;